import { DynamicAssessmentScreen } from '@/components/DynamicAssessmentScreen';

export default function DynamicAssessment() {
  return <DynamicAssessmentScreen />;
}
